<template>
	<div class="zhaobiao">
		<div class="zbo_pc" v-if="!isPhone">
			<div class="zb_list">
				<div class="zb_item flex1" v-for="(item,index) in nelist" :key="index" @click="toDetail(item)">
					<div class="zb_item_left flex3">
						<img src="@/images/pot3.png">
						<div class="ellip">{{ item.title }}</div>
					</div>
					<div class="zb_item_right">{{ item.addtime.slice(0,10) }}</div>
				</div>
			</div>
			<div class="flex2 mt_60">
				<pagination1 :total-pages="totalPage" :total-num="totalNum" :current-page="currentPage"
					@page-change="handlePageChange" />
			</div>
		</div>
		<div class="zbo_ph" v-if="isPhone">
			<div class="zb_list">
				<div class="zb_item flex1" v-for="(item,index) in nelist" :key="index" @click="toDetail(item)">
					<div class="zb_item_left flex3">
						<img src="@/images/pot3.png">
						<div class="ellip">{{ item.title }}</div>
					</div>
					<div class="zb_item_right">{{ item.addtime.slice(0,10) }}</div>
				</div>
			</div>
			<div class="flex2 mt_30">
				<pagination-2 :total-pages="totalPage" :total-num="totalNum" :current-page="currentPage"
					@page-change="handlePageChange" />
			</div>
		</div>
	</div>
</template>

<script>
import pagination1 from "../../components/pagination1.vue";
import pagination2 from "../../components/pagination2.vue";
export default {
	components: {
		pagination1,
		pagination2
	},
	data() {
		return {
			sort: '',//1=招标采购,2=通知公告
			nelist: [],
			currentPage: 1,
			totalPage: 0,
			totalNum: 0,
			staticImg: this.$staticImg,
			isPhone: this.$isMobile,
		}
	},
	watch: {
		$route: {
			handler(newRoute, oldRoute) {
				this.nelist = [];
				this.currentPage = 1;
				this.totalPage = 0;
				this.totalNum = 0;
				this.sort = newRoute.query.sort;
				this.message();
			},
			deep: true
		}
	},
	created() {
		this.sort = this.$route.query.sort;
		this.message();
	},
	methods: {
		// 业务领域
		async message() {
			var data = {
				status: this.sort,//群团工作
				page: this.currentPage - 1,
				nums: 10
			}
			const res = await this.$api.message(data);
			if (res.code == 1) {
				this.totalNum = res.msg;
				this.totalPage = Math.ceil(Number(this.totalNum) / 10);
				if (res.data.length) {
					this.nelist = res.data;
				}
			}
		},
		handlePageChange(newPage) {
			this.currentPage = newPage;
			this.message();
		},
		toDetail(item) {
			this.$router.push("/infoDisclosure/infoDetail?id=" + item.id + "&sort=" + this.sort);
		}
	}
}
</script>

<style lang="scss">
.zhaobiao {
	.zbo_pc {
		.zb_list {
			margin-top: -40px;
			.zb_item {
				height: 72px;
				border-bottom: 1px dashed #d4d4d4;
				cursor: pointer;
				.zb_item_left {
					flex: 1;
					width: 0;
					img {
						width: 11px;
					}
					div {
						margin-left: 15px;
						font-size: 18px;
						color: #717171;
						flex: 1;
						&:hover {
							color: #003f99;
						}
					}
				}
				.zb_item_right {
					font-size: 18px;
					color: #a7a7a7;
					width: 140px;
					text-align: right;
				}
			}
		}
	}
	.zbo_ph {
		padding: 0.35rem;
		.zb_list {
			.zb_item {
				height: 1.5rem;
				border-bottom: 1px dashed #d4d4d4;
				cursor: pointer;
				.zb_item_left {
					flex: 1;
					width: 0;
					img {
						width: 0.268rem;
					}
					div {
						margin-left: 0.36rem;
						font-size: 0.39rem;
						color: #717171;
						flex: 1;
					}
				}
				.zb_item_right {
					font-size: 0.39rem;
					color: #a7a7a7;
					width: 2.8rem;
					text-align: right;
				}
			}
		}
	}
}
</style>